<template>
  <div>
    <topPage :title="title" :bgImg="bgImg" />
    <unitList
      color="#89FBD2"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="list"
    ></unitList>
    <crew
      color="#89FBD2"
      title="NOTRE OFFRES"
      text="Généralement, on utilise un texte en faux latin (le texte ne veut rien dire, il a été modifié), le Lorem ipsum ou Lipsum, qui permet donc de faire office de texte d’attente. L’avantage de le mettre en latin est que"
      :list="crew"
    ></crew>
  </div>
</template>

<script>
import topPage from "../components/topPage";
import unitList from "../components/unitList";
import crew from "../components/crew";
export default {
  name: "Location",
  components: { topPage, unitList, crew },
  data: () => ({
    title: "Location",
    bgImg: "loc_illu.png",
    crew: [
      { img: "test.png", title: "Geraldine Petit", text: "test" },
      { img: "test.png", title: "test", text: "test" },
      { img: "test.png", title: "test", text: "test" }
    ],
    list: [
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      },
      {
        img: "unitTest.png",
        type: "Appartement",
        location: "Paris 12 | 75012",
        price: 1000,
        surface: 40,
        ref: "1837EP"
      }
    ]
  })
};
</script>
